import { IConfig } from '@cian/config/shared';

const PROMO_URL_CONFIG_KEY = 'mortgage-calculator.cianMortgagePromoUrl';

/* istanbul ignore next */
export const getCianMortgagePromoUrl = (config: IConfig): string => {
  return config.getStrict<string>(PROMO_URL_CONFIG_KEY);
};
